import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";
import { IRoleLowFlow } from "../models/role-low-flow.model";
import { StateUseCaseGroupService } from "@app/flow/core/services/state-use-case-group.service";

@Injectable({
	providedIn: "root",
})
export class AuthLowFlowService {
	private keyStorageRole = "userRoleLowFlow";

	userRoles$ = new BehaviorSubject<IRoleLowFlow[]>([]);
	currentRole$ = new BehaviorSubject<IRoleLowFlow>(null);
	userCompany$ = new BehaviorSubject<string>(null);

	constructor(private stateUseCaseGroupService: StateUseCaseGroupService) {}

	bootstrap() {
		const userRolesByUseCase =
			this.stateUseCaseGroupService.useCaseGroup.roles;
		this.userRoles$.next(userRolesByUseCase);
		this.setCurrentRole(this.getCurrentRole());
	}

	setCurrentRole(newRole: IRoleLowFlow) {
		const actualRole = this.currentRole$.getValue();

		if (actualRole?.name !== newRole?.name) {
			this.currentRole$.next(newRole);
			window.localStorage.setItem(
				this.keyStorageRole,
				JSON.stringify(newRole)
			);
		}
	}

	setCompany(company: string) {
		this.userCompany$.next(company);
	}

	getCompany() {
		return this.userCompany$.getValue();
	}

	clear(): void {
		this.userRoles$.next([]);
		this.currentRole$.next(null);
		this.userCompany$.next(null);
		window.localStorage.removeItem(this.keyStorageRole);
	}

	private getCurrentRole(): IRoleLowFlow {
		const defaultRole = this.userRoles$.getValue()[0];

		const role: IRoleLowFlow = JSON.parse(
			window.localStorage.getItem(this.keyStorageRole)
		);

		// default
		if (!role) {
			return defaultRole;
		}

		const exits: boolean = !!this.userRoles$
			.getValue()
			.find(
				(uRole) => uRole.name.toUpperCase() === role.name.toUpperCase()
			);

		return exits ? role : defaultRole;
	}
}
